export default __webpack_public_path__ + "static/media/What can be Tokenized 2 (1).0fb92588.jpg";